import React from "react";
import { useTranslation } from "react-i18next";
import "./SingleCenteredImage.css";

// Replace with your actual image
import heroImage from "../../Assets/eps.png";

export default function SingleCenteredImage() {
  const { t } = useTranslation();

  return (
    <div className="sci-wrapper">
      <div className="sci-container">
        <img src={heroImage} alt={t("sci_title")} className="sci-image" />
        <h2 className="sci-title">{t("sci_title")}</h2>
        <p className="sci-description">{t("sci_description")}</p>
      </div>
    </div>
  );
}
